import dynamic from 'next/dynamic';
import { useLoadingScreen } from './utils/useLoadingScreen';
import styles from './styles.module.scss';

const Lottie = dynamic(() => import('react-lottie-light'), { ssr: false });

const LoadingScreen = (props) => {
  const { loadRef, defaultOptions } = useLoadingScreen(props);

  return (
    <div
      ref={loadRef}
      className={styles.loadingPage}
    >
      <div className={styles.jsonWrapper}>
        <Lottie
          options={defaultOptions}
          speed={1}
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
